export default "__VITE_ASSET__QUxL588i__"